import React, { useEffect } from 'react';
import { ExtendedUseFormReturn } from './useFormHooks';

interface UseValidateAutoCompleteProps {
  formMethods: ExtendedUseFormReturn<any>;
  relevantFields?: string[];
}

export const useValidateAutoComplete = <T extends ExtendedUseFormReturn<any>>({
  formMethods,
  relevantFields,
}: UseValidateAutoCompleteProps) => {
  const { watch, getValues } = formMethods;
  const watchAllFields = watch();
  const oldFieldsValues = React.useRef(getValues());

  useEffect(() => {
    Object.keys(watchAllFields).forEach((key) => {
      const target = key as keyof T;
      if (watchAllFields[target] !== oldFieldsValues.current[target] && relevantFields?.includes(target as string)) {
        const input = document.getElementById(target as string);
        if (input && document.activeElement !== input) {
          formMethods.trigger(target as string);
        } else if (input && document.activeElement === input && formMethods.formState.errors[target]?.message) {
          formMethods.trigger(target as string);
        }
      }
    });

    oldFieldsValues.current = { ...watchAllFields };
  }, [watchAllFields, formMethods, relevantFields]);
};
